import React, { useEffect, useState } from "react";
// import CourseHeader from "../header";
import '../Journal/journal.css'
import Footer from "../footer";
// import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { settingsData } from "../../Redux/home/homeslice";
import Header from "../header";
import { toast } from 'react-toastify';
import { useFormik } from "formik";
import * as Yup from "yup";
import ContentRenderer from "../ContentRender";
import addressImg from "../../assets/img/maps-and-flags.png"
import emailImg from "../../assets/img/email 1.png"
import reprintImg from "../../assets/img/reprint_1.png"
import phoneImg from "../../assets/img/phone-call.png"
// import mapImg from "../../assets/img/google-maps.png"

const ContactUs = () => {

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    message: ""
  });


  const handleSubmitAPI = (values, fun) => {
    // e.preventDefault()
    axios.post(`${process.env.REACT_APP_URL}/home/contactQuery`, values)
      .then((res) => {
        console.log(res?.data)
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          mobile: "",
          message: ""
        })
        toast.success("Detailes Saved !")
        fun();

      })
      .catch((err) => {
        console.log(err?.response?.data)
        toast.error(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data)
      })
    console.log(formData);
  }

  // const handleChange = (event) => {
  //     const { name, value } = event.target;
  //     setFormData((prevData) => ({
  //         ...prevData,
  //         [name]: value
  //     }));
  // };


  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      message: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .min(2, "First name must be at least 2 characters")
        .max(50, "First name cannot exceed 50 characters")
        .required("First name is required"),
      last_name: Yup.string()
        .min(2, "Last name must be at least 2 characters")
        .max(50, "Last name cannot exceed 50 characters")
        .required("Last name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Phone number must be 10 digits")
        .required("Phone number is required"),
      message: Yup.string()
        .min(10, "Message must be at least 10 characters")
        .required("Message is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      console.log("Form data", values);
      handleSubmitAPI(values, resetForm);
      // Add your API call logic here
    },
  });

  const dispatch = useDispatch();
  // const { slug } = useParams();

  useEffect(() => {
    dispatch(settingsData());
  }, [])

  const { settings } = useSelector((state) => state.Home);

  return (
    <>
      <Header />
      {/* <div className="breadcrumb-bar">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="breadcrumb-list">
                <nav aria-label="breadcrumb" className="page-breadcrumb">
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="page-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <h1 className="mb-0">Contact Us</h1>
            </div>
          </div>
        </div>
      </div> */}

      {/*  */}

      <div className="inner-banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="instructor-wrap border-bottom-0 m-0">
                <div className="about-instructor align-items-center"></div>
              </div>
              <h2>{"Journals Feed"}</h2>
              {/* <p
                                dangerouslySetInnerHTML={{
                                  __html: homeJournalDataById?.data?.[0]?.journal_homes?.[0]?.about_journal,
                                }}
                                className="truncate-two-lines"
                              ></p> */}

              <div
                className="course-info d-flex align-items-end border-bottom-0 m-0 p-0 "
                style={{ justifyContent: "end" }}
              >
                <div className="row">
                  <div className="col-md-12 col-12">
                    <h1 className="mb-0"  style={{color:"white"}}>Contact Us</h1>
                  </div>
                </div>
              </div>
              <div
                className="course-info d-flex align-items-end border-bottom-0 m-0 p-0"
                style={{ justifyContent: "start" }}
              >
                {/* <div className="cou-info">
                                  <div className="all-btn all-category">
                                    <Link
                                      to={props?.name ? `/${props?.name}/manuscript-form` : "/online-submission"}
                                      className="btn btn-primary"
                                    >
                                      Submit Manuscript
                                    </Link>
                                  </div>  
                                </div> */}
              </div>
            </div>

          </div>
        </div>
      </div>


      {/*  */}


      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 mx-auto">
              <div className="support-wrap">
                <div className="row">
                  <div className="col-md-5 col-lg-5 col-xl-5 col-sm-6">
                    {settings?.data?.address &&
                      <>
                        <div style={{ display: "flex" }}>
                          <img src={addressImg} alt="addressimg" style={{ width: "21px", height: "21px" }} />
                          <strong className="ms-1">Address</strong>
                        </div>
                        <br />
                        <label >
                          <ContentRenderer content={settings?.data?.address} />
                        </label>
                      </>
                    }
                    <br />
                    {settings?.data?.registered_address &&
                      <>
                        <div style={{ display: "flex" }}>
                          <img src={addressImg} alt="addressimg" style={{ width: "21px", height: "21px" }} />
                          <strong className="ms-1">Registered Address</strong>
                        </div>
                        <br />
                        <label
                        >
                          <ContentRenderer content={settings?.data?.registered_address} />
                        </label>
                      </>
                    }
                    <br />
                    {settings?.data?.phone &&
                      <>
                        <div style={{ display: "flex" }}>
                          <img src={phoneImg} alt="addressimg" style={{ width: "21px", height: "21px" }} />
                          <strong className="ms-1">Phone Number</strong>
                        </div>
                        <br />
                        <label>
                          {settings?.data?.phone}
                        </label>
                      </>
                    }
                    <br />
                    {settings?.data?.email &&
                      <>
                        <div style={{ display: "flex" }}>
                          <img src={emailImg} alt="addressimg" style={{ width: "21px", height: "21px" }} />
                          <strong className="ms-1">Email</strong>
                        </div>
                        <br />
                        <label>
                          {settings?.data?.email}
                        </label>
                      </>
                    }
                    <br />
                    {settings?.data?.reprint_advertisement &&
                      <>
                        <div style={{ display: "flex" }}>
                          <img src={reprintImg} alt="addressimg" style={{ width: "21px", height: "21px" }} />
                          <strong className="ms-1"  >Reprints / Advertisement</strong>
                        </div>
                        <br />
                        <label>
                          {settings?.data?.reprint_advertisement}
                        </label>
                      </>
                    }
                  </div>
                  <div className="col-md-6 col-lg-6 col-xl-6 col-sm-6">
                    {/* <form onSubmit={handleSubmitAPI} >
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label>First Name</label>
                                                        <input
                                                            name="first_name"
                                                            value={formData.first_name}
                                                            onChange={handleChange}
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter your first name"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label>Last Name</label>
                                                        <input
                                                            name="last_name"
                                                            value={formData.last_name}
                                                            onChange={handleChange}
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter your last name"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label>Email</label>
                                                        <input
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                            type="email"
                                                            className="form-control"
                                                            placeholder="Enter your email address"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label>Phone</label>
                                                        <input
                                                            name="mobile"
                                                            value={formData.mobile}
                                                            onChange={handleChange}
                                                            type="tel"
                                                            className="form-control"
                                                            placeholder="Enter your phone number"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label>Message</label>
                                                        <textarea
                                                            name="message"
                                                            value={formData.message}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                            placeholder="Write down here"
                                                            rows={4}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <button className="btn-submit">Submit</button>
                                                </div>
                                            </div>
                                        </form> */}
                    <form onSubmit={formik.handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>First Name</label>
                            <input
                              name="first_name"
                              type="text"
                              className={formik.touched.first_name && formik.errors.first_name ? "form-control is-invalid" : "form-control"}
                              placeholder="Enter your first name"
                              value={formik.values.first_name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {/* {formik.touched.first_name && formik.errors.first_name ? (
              <div className="error">{formik.errors.first_name}</div>
            ) : null} */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Last Name</label>
                            <input
                              name="last_name"
                              type="text"
                              className={formik.touched.last_name && formik.errors.last_name ? "form-control is-invalid" : "form-control"}
                              placeholder="Enter your last name"
                              value={formik.values.last_name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {/* {formik.touched.last_name && formik.errors.last_name ? (
              <div className="error">{formik.errors.last_name}</div>
            ) : null} */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              name="email"
                              type="email"
                              className={formik.touched.email && formik.errors.email ? "form-control is-invalid" : "form-control"}
                              placeholder="Enter your email address"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {/* {formik.touched.email && formik.errors.email ? (
              <div className="error">{formik.errors.email}</div>
            ) : null} */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Phone</label>
                            <input
                              name="mobile"
                              type="tel"
                              className={formik.touched.mobile && formik.errors.mobile ? "form-control is-invalid" : "form-control"}
                              placeholder="Enter your phone number"
                              value={formik.values.mobile}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.mobile && formik.errors.mobile ? (
                              <div className="error">{formik.errors.mobile}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label>Message</label>
                            <textarea
                              name="message"
                              className={formik.touched.message && formik.errors.message ? "form-control is-invalid" : "form-control"}
                              placeholder="Write down here"
                              rows={4}
                              value={formik.values.message}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {/* {formik.touched.message && formik.errors.message ? (
              <div className="error">{formik.errors.message}</div>
            ) : null} */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default ContactUs